import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router';

import { AGENT_SCREEN_PATHS } from '@accio3d/shared/agent';

export type ScreenContext = {
  path: string;
  params: Record<string, string>;
};

export const AGENT_SCREEN_PATTERNS = AGENT_SCREEN_PATHS;

export function resolveScreenContext(pathname: string): ScreenContext | null {
  for (const pattern of AGENT_SCREEN_PATTERNS) {
    const match = matchPath({ path: pattern, end: true }, pathname);
    if (!match) continue;

    const params: Record<string, string> = {};
    for (const [key, value] of Object.entries(match.params)) {
      if (typeof value === 'string' && value.length > 0) params[key] = value;
    }
    return { path: pattern, params };
  }
  return null;
}

export function useScreenContext(): ScreenContext | null {
  const { pathname } = useLocation();
  return useMemo(() => resolveScreenContext(pathname), [pathname]);
}
